module.exports = __webpack_public_path__ + "static/img/yx02.f26fcf8f.png";